import { render, staticRenderFns } from "./updatePwd.vue?vue&type=template&id=2a5da638&scoped=true&"
import script from "./updatePwd.vue?vue&type=script&lang=js&"
export * from "./updatePwd.vue?vue&type=script&lang=js&"
import style0 from "./updatePwd.vue?vue&type=style&index=0&id=2a5da638&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5da638",
  null
  
)

export default component.exports